import { useTranslation } from "react-i18next";
import { useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useState } from "react";
import Box from "@mui/material/Box";
import Layout from "../shared/components/LayoutComponent";
import List from "@mui/material/List";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Page from "../shared/components/PageComponent";
import { useMessage } from "../../context/message-context";
import { Autocomplete, Badge, Button, Chip, Divider, IconButton, ListItem, ListItemIcon, ListItemText, Stack, Table, TextField } from "@mui/material";
import { FullPageSpinner } from "../lib";
import { fetchNewsUpdates } from "./fetchNewsUpdates";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { styled } from "@mui/styles";

function NewsAuswahl({ client, accessToken, updateTitle }) {
  const { t } = useTranslation();
  const [filesArray, setFilesArray] = useState([]);
  const [progammsArray, setProgrammsArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filter1, setFilter1] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [selectedTab, setSelectedTab] = useState(0);
  const { showErrorMessage } = useMessage();
  const navigate = useNavigate();

  function onNewsEntryClick(entryId) {
    navigate("/NEWS/NEWSID?entryId=" + entryId);
  }

  const filteredArray = useMemo(() => {
    if (!filesArray || filesArray.length < 1) return [];
    return filesArray.filter((m) => {
      if (!filter1) return m;
      const matchesFilter1 = m.betreff.toLowerCase().trim().includes(filter1.toLowerCase().trim());
      const matchesFilter2 = m.betrefftitel.toLowerCase().trim().includes(filter1.toLowerCase().trim());
      return matchesFilter1 || matchesFilter2;
    });
  }, [filesArray, filter1]);

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
        {value === index && children}
      </div>
    );
  }

  useEffect(() => {
    updateTitle("News Ticker");
    setIsLoading(true);

    fetchNewsUpdates("HOLE_ALLE_NEWS_EINTRAEGE", accessToken, "")
      .then((data) => {
        if (data && data.newseintraege && data.newseintraege.length > 0) {
          setFilesArray(data.newseintraege);
          let tempArray = [];
          data.newseintraege.map((m) => {
            if (!tempArray.includes(m.betrefftitel)) tempArray.push(m.betrefftitel);
          });
          setProgrammsArray(tempArray);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const StyledBadge = styled(Badge)(() => ({
    "& .MuiBadge-badge": {
      top: "50%",
    },
  }));

  const tabContent = (m, gelesenStatus) => {
    return (
      <Box sx={{ paddingTop: 1 }} key={m.key}>
        <StyledBadge
          color="primary"
          variant="dot"
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          invisible={gelesenStatus}
          sx={{ inset: 0, width: "100%", opacity: gelesenStatus ? "0.6" : "1", display: { xs: "table", sm: "flex" } }}
        >
          <ListItem
            style={{ cursor: "pointer" }}
            hover
            onClick={() => {
              onNewsEntryClick(m.key);
            }}
          >
            <ListItemText primary={m.datum} />
            <ListItemText sx={{ width: "50%", marginRight: 1 }} primary={m.betreff} secondary={m.betrefftitel} />
            {m.likes && Number(m.likes.trim()) > 0 ? (
              <Stack direction={"row"} gap={0.5} alignItems={"center"} sx={{ opacity: 0.6, width: "15%" }}>
                <Typography variant="h6">{m.likes.trim()}</Typography>
                <ListItemIcon>
                  <ThumbUpIcon fontSize="small" />
                </ListItemIcon>
              </Stack>
            ) : (
              <Box sx={{ width: "15%" }}></Box>
            )}
          </ListItem>
        </StyledBadge>
        <Divider variant="middle" />
      </Box>
    );
  };

  return (
    <>
      {isLoading && <FullPageSpinner />}
      <Page>
        <Layout>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container>
              <Grid item xs={12} md={12} lg xl>
                <Box p={2}>
                  <Stack spacing={2}>
                    <Autocomplete
                      id="filter1"
                      value={filter1}
                      onChange={(event, newValue) => {
                        setFilter1(newValue);
                      }}
                      inputValue={inputValue}
                      onInputChange={(event, newInputValue) => {
                        setFilter1(newInputValue);
                        setInputValue(newInputValue);
                      }}
                      freeSolo
                      options={progammsArray}
                      renderInput={(params) => <TextField {...params} label={t("Suche")} />}
                    />
                  </Stack>
                </Box>

                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs value={selectedTab} onChange={(event, newValue) => setSelectedTab(newValue)} aria-label="basic tabs example">
                    <Tab label={t("Alle")} id="tabAll" />
                    <Tab label={t("Ungelesen")} id="tabUnRead" />
                    <Tab label={t("Gelesen")} id="tabRead" />
                  </Tabs>
                </Box>
                <CustomTabPanel sx={{ padding: 0 }} value={selectedTab} index={0}>
                  <List sx={{ padding: 1.5 }}>
                    {filteredArray &&
                      filteredArray.length > 0 &&
                      filteredArray.map((m) => {
                        let gelesenStatus;
                        if (m.statustext === "gelesen") {
                          gelesenStatus = true;
                        } else {
                          gelesenStatus = false;
                        }
                        return tabContent(m, gelesenStatus);
                      })}
                  </List>
                </CustomTabPanel>
                <CustomTabPanel value={selectedTab} index={1}>
                  <List sx={{ padding: 1.5 }}>
                    {filteredArray &&
                      filteredArray.length > 0 &&
                      filteredArray
                        .filter((m) => {
                          return m.statustext === "ungelesen";
                        })
                        .map((m) => {
                          const gelesenStatus = false;
                          return tabContent(m, gelesenStatus);
                        })}
                  </List>
                </CustomTabPanel>
                <CustomTabPanel value={selectedTab} index={2}>
                  <List sx={{ padding: 1.5 }}>
                    {filteredArray &&
                      filteredArray.length > 0 &&
                      filteredArray
                        .filter((m) => {
                          return m.statustext === "gelesen";
                        })
                        .map((m) => {
                          const gelesenStatus = true;
                          return tabContent(m, gelesenStatus);
                        })}
                  </List>
                </CustomTabPanel>
              </Grid>
            </Grid>
          </Box>
        </Layout>
      </Page>
    </>
  );
}

export default NewsAuswahl;
